import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { localeJaJP } from '@/locales/ja-JP';
import { localeEnUS } from '@/locales/en-US';

// vue-i18n
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'ja',
  fallbackLocale: 'en',
  messages: {
    ja: localeJaJP,
    en: localeEnUS,
  },
});

export default i18n;
